module.exports = __webpack_public_path__ + "static/img/ghoul1.8b49d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/ghoul1.png
// module id = c3Ej
// module chunks = 0